<template>
  <OverlayLoader :visible="isLoading" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div
        class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4"
      >
        <form class="position-relative table-src-form me-0" @submit.prevent>
          <div class="row">
            <div class="col-lg-4 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Asunto</label>
                <input
                  type="text"
                  v-model.trim="filters.subject"
                  class="form-control h-45"
                  placeholder="Ingrese asunto"
                />
              </div>
            </div>
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Tipo</label>
                <select
                  v-model="filters.typeId"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="notificationType.id"
                    v-for="(notificationType, i) of itemsNotificationTypes"
                    :key="i"
                  >
                    {{ notificationType.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-6 col-sm-6 text-end mt-4">
              <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                <button
                  type="button"
                  @click.prevent="getNotifications(currentPage)"
                  class="btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                >
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="default-table-area style-two default-table-width">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col" class="text-center">Asunto</th>
                <th scope="col" class="text-center">Tipo</th>
                <th scope="col" class="text-center">Fecha <br />creación</th>
                <th scope="col" class="text-center">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 + (currentPage - 1) * pageSize }}
                </td>
                <td>{{ item.subject }}</td>
                <td>{{ item.typeStr }}</td>
                <td class="text-body">{{ item.createdAtDateTimeString }}</td>
                <td class="text-center">
                  <div class="">
                    <RouterLink :to="`/notification/edit/${item.id}`">
                      <i class="material-symbols-outlined fs-16 text-primary">
                        edit
                      </i>
                    </RouterLink>
                    <button
                      class="ps-2 border-0 bg-transparent lh-1 position-relative"
                      @click="notificationScheduleModal(item.id)"
                    >
                      <i class="material-symbols-outlined fs-16 text-primary">
                        settings
                      </i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="p-4 pt-lg-4">
          <Pagination
            :currentPage="currentPage"
            :pageSize="pageSize"
            :totalItems="totalItems"
            @update:page="fetchPage"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    id="mdlNotificationSchedules"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlNotificationSchedulesLabel"
    aria-hidden="true"
    size="large"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlNotificationSchedulesLabel">
            Fecha de Notificaciones
          </h1>
        </div>
        <div class="modal-body">
          <form @submit.prevent="validateForm">
            <div class="row">
              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-4">
                  <label class="label text-secondary strong">Fecha</label>
                  <VueDatePicker
                    placeholder="Fecha y hora"
                    v-model="notificationSchedule.scheduleDate"
                    format="dd/MM/yyyy HH:mm"
                    :format-locale="es"
                    @input="clearError('scheduleDate')"
                    :minutes-increment="1"
                    :enable-time-picker="true"
                    is-24
                    teleport
                  />
                  <div class="input-error">{{ errors.scheduleDate }}</div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-4"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-4">
                  <button
                    class="btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4"
                    type="submit"
                    :disabled="isLoading"
                  >
                    <span v-if="!isLoading">{{
                      notificationSchedule.id == 0
                        ? "Crear Fecha"
                        : "Actualizar Fecha"
                    }}</span>
                    <span
                      class="spinner-border spinner-border-sm me-2"
                      aria-hidden="true"
                      v-if="isLoading"
                    ></span>
                    <span role="status" v-if="isLoading">Procesando...</span>
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div class="row">
            <div class="default-table-area style-two">
              <div class="table-responsive">
                <table class="table align-middle">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col" class="text-center">Fecha Programada</th>
                      <th scope="col" class="text-center">Fecha Registro</th>
                      <th scope="col" class="text-center">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in notificationSchedules"
                      :key="item.id"
                    >
                      <td>
                        {{ index + 1 }}
                      </td>
                      <td>{{ item.scheduleDateTimeString }}</td>
                      <td>{{ item.createdAtDateTimeString }}</td>
                      <td class="text-center">
                        <div class="">
                          <button
                            class="ps-2 border-0 bg-transparent lh-1 position-relative"
                            @click="editNotificationSchedule(item)"
                          >
                            <i
                              class="material-symbols-outlined fs-16 text-primary"
                            >
                              edit
                            </i>
                          </button>
                          <button
                            class="ps-2 border-0 bg-transparent lh-1 position-relative"
                            @click="deleteNotificationSchedule(item.id)"
                          >
                            <i
                              class="material-symbols-outlined fs-16 text-primary"
                            >
                              delete
                            </i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger text-white"
            @click="closeNotificationSchedule"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";
import { useToast } from "vue-toastification";
import api from "@/services/api";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import { PAGINATION_ITEMS_PER_PAGE, STATUS, LABELS } from "@/utils/constants";
import moment from "moment";
import Swal from "sweetalert2";
import { notificationScheduleSchema } from "@/schemas/notificationScheduleSchema";
// Create FilePond component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview
);

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Notifications",
  components: {
    Pagination,
    OverlayLoader,
  },
  setup() {
    const toast = useToast();
    const isLoading = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(PAGINATION_ITEMS_PER_PAGE);
    const totalItems = ref(0);
    const modalNotificationSchedule = ref<any>(null);
    const itemsNotificationTypes = ref<any[]>([]);
    const items = ref<any[]>([]);
    const notificationSchedules = ref<any[]>([]);
    const filters = ref({
      subject: "",
      typeId: null,
    });
    const notificationSchedule = ref({
      configurationNotificationId: 0,
      id: 0,
      scheduleDate: "",
    });
    const errors = ref<Record<string, string>>({});
    interface NotificationSchedule {
      id: number;
      scheduleDate: string;
      configurationNotificationId: number;
    }
    onMounted(async () => {
      await getNotificationTypes();
      await getNotifications(currentPage.value);
      const modalElement = document.getElementById("mdlNotificationSchedules");
      if (modalElement) {
        modalNotificationSchedule.value = new window.bootstrap.Modal(
          modalElement
        );
        modalNotificationSchedule.value.hide();
      }
    });
    const editNotificationSchedule = (obj: NotificationSchedule) => {
      notificationSchedule.value = obj;
      notificationSchedule.value.scheduleDate = moment(obj.scheduleDate).format(
        "YYYY-MM-DD HH:mm"
      );
    };
    const validateForm = async () => {
      try {
        errors.value = {};
        await notificationScheduleSchema.validate(notificationSchedule.value, {
          abortEarly: false,
        });
        isLoading.value = true;

        await createNotificationSchedule();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };

    const createNotificationSchedule = async () => {
      try {
        const payload = {
          ...notificationSchedule.value,
          scheduleDate: moment(
            notificationSchedule.value.scheduleDate
          ).toISOString(),
        };
        const response: any = await api.post(
          `/notification/notificationschedule`,
          payload
        );
        if (response.data != 0) {
          toast.success(
            `La fecha de programada fue ${
              notificationSchedule.value.id == 0 ? "creada" : "actualizada"
            } con éxito.`,
            {
              timeout: 2000,
            }
          );
          clearNotificationSchedule();
          getNotificationSchedules(
            notificationSchedule.value.configurationNotificationId
          );
        }
      } catch (ex: any) {
        console.error(ex);
        let mensaje = "La fecha de programada no pudo ser creada.";
        if (ex.response?.data) {
          const raw = ex.response.data;
          if (typeof raw === "string") {
            const match = raw.match(/System\.Exception:\s*(.*)/);
            mensaje = match ? match[1] : raw;
          }
        }
        toast.error(mensaje, {
          timeout: 2000,
        });
      }
    };

    const deleteNotificationSchedule = async (id: number, status: boolean) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>eliminar</b> la fecha?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Sí `,
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        try {
          isLoading.value = true;

          var obj = {
            id: id,
          };

          const response: any = await api.put(
            `/notification/notificationschedule`,
            obj
          );

          if (response != 0) {
            toast.success(`La fecha fue eliminada con éxito.`, {
              timeout: 2000,
            });
            getNotificationSchedules(
              notificationSchedule.value.configurationNotificationId
            );
          } else {
            toast.error(`La fecha no pudo ser eliminada.`, {
              timeout: 2000,
            });
          }
          isLoading.value = false;
        } catch (ex: any) {
          console.error(ex);
          let mensaje = "La fecha programada no pudo ser eliminada.";
          if (ex.response?.data) {
            const raw = ex.response.data;
            if (typeof raw === "string") {
              const match = raw.match(/System\.Exception:\s*(.*)/);
              mensaje = match ? match[1] : raw;
            }
          }
          toast.error(mensaje, {
            timeout: 2000,
          });
          isLoading.value = false;
        }
      }
    };

    const notificationScheduleModal = async (id: number) => {
      try {
        getNotificationSchedules(id);
        notificationSchedule.value.configurationNotificationId = id;
        modalNotificationSchedule.value.show();
      } catch (ex) {
        console.error(ex);
      }
    };
    const closeNotificationSchedule = () => {
      clearNotificationSchedule();
       modalNotificationSchedule.value.hide();
    };
        const clearNotificationSchedule = () => {
      notificationSchedule.value.id = 0;
      notificationSchedule.value.scheduleDate = "";
    };
    const getNotificationSchedules = async (id: number) => {
      try {
        isLoading.value = true;
        const response = await api.get(
          `/notification/list-notificationschedule?id=${id}`
        );
        notificationSchedules.value = response.data;
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };
    const getNotificationTypes = async () => {
      try {
        const response = await api.get(`/common/notification-type`);
        itemsNotificationTypes.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };

    const getNotifications = async (page: number) => {
      try {
        isLoading.value = true;
        var params = `pageNumber=${page}&pageSize=${pageSize.value}`;
        if (filters.value.subject) {
          params = params + `&subject=${filters.value.subject}`;
        }
        if (filters.value.typeId) {
          params = params + `&typeId=${filters.value.typeId}`;
        }

        const response = await api.get(
          `/notification/list-notifications?${params}`
        );

        items.value = response.data.list;
        totalItems.value = response.data.rows;
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };

    const fetchPage = async (page: number) => {
      currentPage.value = page;
      getNotifications(currentPage.value);
    };
    return {
      items,
      itemsNotificationTypes,
      currentPage,
      pageSize,
      totalItems,
      STATUS,
      LABELS,
      OverlayLoader,
      filters,
      isLoading,
      getNotifications,
      fetchPage,
      notificationScheduleModal,
      getNotificationSchedules,
      notificationSchedules,
      notificationSchedule,
      createNotificationSchedule,
      editNotificationSchedule,
      deleteNotificationSchedule,
      errors,
      validateForm,
      closeNotificationSchedule,
      clearNotificationSchedule,
    };
  },
});
</script>
